(function () {
  const selector = '[data-shoppable-setup]';

  function initialize(container) {
    const roots = [];
    if (container instanceof Element && container.matches(selector)) roots.push(container);
    if (container.querySelectorAll) roots.push(...container.querySelectorAll(selector));

    roots.forEach((root) => {
      if (root.dataset.shoppableInitialized === 'true') return;
      root.dataset.shoppableInitialized = 'true';

      const panel = root.querySelector('[data-product-card-container]');
      const hotspots = Array.from(root.querySelectorAll('[data-hotspot-button]'));
      const products = Array.from(root.querySelectorAll('[data-product-card]'));
      let activeHotspot = null;
      let positionFrame = 0;

      function positionPanel() {
        if (!activeHotspot || panel.hidden) return;

        const scene = root.querySelector('.smile-pro-shoppable__scene');
        const sceneRect = scene.getBoundingClientRect();
        const hotspotRect = activeHotspot.getBoundingClientRect();
        const panelWidth = panel.offsetWidth;
        const panelHeight = panel.offsetHeight;
        const inset = 8;
        const gap = 14;
        const pinX = hotspotRect.left + hotspotRect.width / 2 - sceneRect.left;
        const pinY = hotspotRect.top + hotspotRect.height / 2 - sceneRect.top;
        const room = {
          right: sceneRect.width - pinX - gap - inset,
          left: pinX - gap - inset,
          below: sceneRect.height - pinY - gap - inset,
          above: pinY - gap - inset,
        };

        let side = 'right';
        if (room.right >= panelWidth) side = 'right';
        else if (room.left >= panelWidth) side = 'left';
        else if (room.below >= panelHeight) side = 'below';
        else if (room.above >= panelHeight) side = 'above';
        else {
          const candidates = [
            ['right', room.right],
            ['left', room.left],
            ['below', room.below],
            ['above', room.above],
          ];
          side = candidates.reduce((best, candidate) => candidate[1] > best[1] ? candidate : best)[0];
        }

        let left = pinX - panelWidth / 2;
        let top = pinY - panelHeight / 2;
        if (side === 'right') left = pinX + gap;
        if (side === 'left') left = pinX - gap - panelWidth;
        if (side === 'below') top = pinY + gap;
        if (side === 'above') top = pinY - gap - panelHeight;

        left = Math.max(inset, Math.min(left, sceneRect.width - panelWidth - inset));
        top = Math.max(inset, Math.min(top, sceneRect.height - panelHeight - inset));
        panel.style.left = `${left}px`;
        panel.style.top = `${top}px`;
      }

      function schedulePosition() {
        cancelAnimationFrame(positionFrame);
        positionFrame = requestAnimationFrame(positionPanel);
      }

      function closePanel(returnFocus) {
        panel.hidden = true;
        panel.style.removeProperty('left');
        panel.style.removeProperty('top');
        root.classList.remove('is-product-open');
        hotspots.forEach((hotspot) => hotspot.setAttribute('aria-expanded', 'false'));
        products.forEach((product) => { product.hidden = true; });
        if (returnFocus && activeHotspot) activeHotspot.focus();
        activeHotspot = null;
      }

      function openPanel(hotspot) {
        const productId = hotspot.dataset.productId;
        const product = products.find((item) => item.dataset.productCard === productId);
        if (!product) return;

        if (activeHotspot === hotspot && !panel.hidden) {
          closePanel(false);
          return;
        }

        hotspots.forEach((item) => item.setAttribute('aria-expanded', item === hotspot ? 'true' : 'false'));
        products.forEach((item) => { item.hidden = item !== product; });
        panel.hidden = false;
        root.classList.add('is-product-open');
        activeHotspot = hotspot;
        schedulePosition();
      }

      root.addEventListener('click', (event) => {
        const closeButton = event.target.closest('[data-card-close]');
        if (closeButton) {
          closePanel(true);
          return;
        }

        const hotspot = event.target.closest('[data-hotspot-button]');
        if (hotspot) {
          openPanel(hotspot);
          return;
        }

        if (!panel.hidden && !event.target.closest('[data-product-card-container]')) closePanel(false);
      });

      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !panel.hidden) {
          event.preventDefault();
          closePanel(true);
        }
      });

      window.addEventListener('resize', schedulePosition, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
